import CallDetails from "../CallDetails/CallDetails";

const AuditReport = () => {
  return (
    <CallDetails viewType={"report"}/>
  );
};

export default AuditReport;
